import type { Chat } from "@virtual-brain-lib/types";

export function abortChatStream(chatId: Chat["id"]): void {
	window.dispatchEvent(new CustomEvent("abortChatStream", { detail: { chatId } }));
}
